import { createConfig } from '@privy-io/wagmi';
import { http } from 'wagmi';
import { base, baseSepolia } from 'viem/chains';

const isMainnet = process.env.NEXT_PUBLIC_CHAIN_ID === '8453';

export const wagmiConfig = isMainnet
  ? createConfig({
      chains: [base],
      transports: { [base.id]: http(process.env.NEXT_PUBLIC_RPC_URL || base.rpcUrls.default.http[0]) },
      ssr: true,
    })
  : createConfig({
      chains: [baseSepolia],
      transports: { [baseSepolia.id]: http(process.env.NEXT_PUBLIC_RPC_URL || baseSepolia.rpcUrls.default.http[0]) },
      ssr: true,
    });

declare module 'wagmi' {
  interface Register {
    config: typeof wagmiConfig;
  }
}
